import { Container, Breadcrumb } from 'react-bootstrap';
import { useParams, Link } from 'react-router-dom';
import './style.scss';
import Paper from '../../components/Paper';
import { useEffect, useState } from 'react';
import { ITicket, ITicketPatchRequest } from '../../commons/interfaces/ticket.interface';
import ChatbotAPI from '../../services/chatbot.service';
import ChatPaperHeader from './ChatPaperHeader';
import useAuth from '../../hooks/auth.hook';
import useUnit from '../../hooks/unit.hook';
import ChatBody from './ChatBody';

const chatbotAPI = new ChatbotAPI();

export default function Chat() {
  const { user } = useAuth();
  const { units } = useUnit();
  const params = useParams();
  const managerId = user?.id as string;

  const [ticket, setTicket] = useState<ITicket | null>(null);
  const [ticketLoading, setTicketLoading] = useState(false);

  // fetching ticket defailt
  useEffect(() => {
    const fetchData = async () => {
      setTicketLoading(true);
      const response = await chatbotAPI.getTicket(params.ticketId as string);
      setTicket(response.data.data);
      setTicketLoading(false);
    };
    fetchData();
  }, [params.ticketId]);

  const handleActionClick = async () => {
    const nextStatus = ticket?.status === 'WAITING' ? 'EXECUTING' : 'CLOSED';
    const body: ITicketPatchRequest = { status: nextStatus, manager: { id: managerId } };
    const response = await chatbotAPI.modifyTicket(params.ticketId as string, body);
    setTicket(response.data);
  };

  if (!ticket) {
    return null;
  }

  return (
    <Container className="">
      <Breadcrumb>
        <Breadcrumb.Item active>Atención chatbot</Breadcrumb.Item>
        <Breadcrumb.Item linkAs={Link} linkProps={{ to: './../' }}>
          {units.find((unit) => unit.id === params.unitId)?.name}
        </Breadcrumb.Item>
        {ticketLoading ? null : <Breadcrumb.Item active>{ticket.customer.name}</Breadcrumb.Item>}
      </Breadcrumb>
      <Paper>
        <ChatPaperHeader ticket={ticket} onActionClick={handleActionClick} managerId={managerId} />
        <ChatBody ticket={ticket} />
      </Paper>
    </Container>
  );
}
